import PropTypes from 'prop-types';
const commonPropTypes = {
    elmId: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    showError: PropTypes.bool,
    fluid: PropTypes.bool,
    hideWrapper: PropTypes.bool,
    focused: PropTypes.bool,
};
export default commonPropTypes;
//# sourceMappingURL=commonPropTypes.js.map